import axios from 'axios';
import baseURLv1 from '@/services/APIConfig.js';

import helpers from '../helpers';

export default {
  namespaced: true,
  state: {
    isTokenRefreshLoading: null,
    token: null,
    refreshToken: null,
  },
  mutations: {
    SET_TOKEN_DATA(state, tokenString) {
      state.token = tokenString;
      localStorage.setItem('token', tokenString);

    },
    SET_TOKENS(state, tokens) {
      state.token = tokens[0];
      state.refreshToken = tokens[1];
      localStorage.setItem('token', tokens[0]);
      localStorage.setItem('refreshToken', tokens[1]);
    },
    CLEAR_TOKEN_DATA() {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      location.replace('/login');
    },
  },
  actions: {
    async login({
      commit,
    }, credentials) {
      return axios
        .post(`${baseURLv1}/user/auth/obtain_token/`, credentials)
        .then(({
          data,
        }) => {
          commit('SET_TOKENS', [data.token, data.refresh_token]);
        });
    },
    async refreshToken({
      commit,
      dispatch,
    }, payload) {
      if (!localStorage.getItem('token')) {
        dispatch('auth/logout');
        return;
      }
      const refreshToken = localStorage.getItem('refreshToken');
      if (this.state.auth.isTokenRefreshLoading != null) {
        return this.state.auth.isTokenRefreshLoading.then((response) => {
          this.state.auth.isTokenRefreshLoading = null;
          return response;
        }).catch((error) => {
          this.state.auth.isTokenRefreshLoading = null;
          throw error;
        });
      }

      try {
        this.state.auth.isTokenRefreshLoading = new Promise(async(resolve, reject) => {
          try {
            const response = await axios.post(baseURLv1 + '/user/auth/refresh_token/', {
              token: refreshToken,
            }, {
              headers: {
                'Authorization': `JWT ${refreshToken}`,
                'X-IT-CODE-LOCATION': payload && payload.location ? payload.location : 'unknown',
              },
            });
            resolve(response);
          } catch (e) {
            reject(e);
          }
        });

        return this.state.auth.isTokenRefreshLoading.then((response) => {
          this.state.auth.isTokenRefreshLoading = null;
          return response;
        }).catch((error) => {
          this.state.auth.isTokenRefreshLoading = null;
          throw error;
        });
      } catch (e) {
        throw e;
      }
    },
    verifyToken() {
      return axios.post(baseURLv1 + '/user/auth/verify_token/', {
        token: localStorage.getItem('token'),
      });
    },
    async logout({
      commit,
    }) {
      await axios.delete(baseURLv1 + '/user/auth/invalidate_token/', {
        refresh_token: localStorage.getItem('refreshToken'),
      }).catch((error) => console.error(error));

      helpers.removeAllLocalStorage();

      clearInterval(this.$refreshNotificationsInterval);
      commit('CLEAR_TOKEN_DATA');
    },
  },
  getters: {
    loggedIn(state) {
      return !!state.token;
    },
  },
};
